import { Alert, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { COLORS } from '../utils/colors.js';

export const StyledContent = styled(Box)({
  width: '100%',
  lineHeight: '20px'
});

export const StyledTitle = styled(Typography)({
  fontSize: '16px',
  marginRight: '6px'
});

export const StyledDescription = styled(Typography)({
  '& p': {
    margin: 0,
    display: 'inline'
  },
  '& a': {
    color: 'inherit'
  }
});

export const StyledAlert = styled(Alert)({
  backgroundColor: COLORS.secondary,
  alignItems: 'flex-start',
  borderRadius: 0,
  padding: '4px 16px',
  '& .MuiAlert-icon': {
    color: COLORS.white,
    fontSize: '20px',
    padding: '4px 0',
    marginRight: '8px',
    marginTop: '2.5px'
  },
  '& .MuiAlert-message': {
    padding: '4px 0'
  }
});
